import { API_BASE_URL } from "common/constants";
import { Key } from "swr";
import { KeyedObject } from "types/root";

async function handleResponse(response: KeyedObject) {
  if (!response.ok) {
    // Manually throw an error for bad HTTP statuses
    const errorData = await response.json(); 
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  // Check if response has content before parsing as JSON
  if (response.status !== 204 && response.headers.get("content-length") !== "0") {
    return response.json();
  }
  return null; // Return null for no-content responses
}


export const fetchService = {

  getToken: () => {
    // TODO - may have to refactor
    const auth = JSON.parse(localStorage.getItem('auth') || '{}');
    return auth && auth.token ? auth.token : '';
  },

  get: async (url: string, params: KeyedObject | void) => {
    const queryString = params ? `${new URLSearchParams(params).toString()}` : ''
    const token = fetchService.getToken()
    const headers: KeyedObject = token ? { "Authorization": `Token ${token}` } : {};

    return fetch(`${API_BASE_URL}${url}?${queryString}`, {
      headers: headers
    })
  },

  post: async (url: string, data: KeyedObject) => {

    const token = fetchService.getToken()
    const headers: KeyedObject = token ? {
      "Authorization": `Token ${token}`
    } : {};

    headers["Content-Type"] = "application/json"

    return fetch(`${API_BASE_URL}${url}`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    })
  },

  postFD: async (url: string, data: KeyedObject, files: KeyedObject) => {

    const token = fetchService.getToken()
    const headers: KeyedObject = token ? {
      "Authorization": `Token ${token}`
    } : {};

    const formData = new FormData();

    for (const [key, value] of Object.entries(data)) {
        // @ts-ignore
        formData.append(key, value);
    }

    for (const [key, value] of Object.entries(files)) {
        // @ts-ignore
        formData.append(key, value);
    }    

    return fetch(`${API_BASE_URL}${url}`, {
      method: 'POST',
      headers: headers,
      body: formData
    })

  },

  put: async (url: string, data: KeyedObject) => {

    const token = fetchService.getToken()
    const headers: KeyedObject = token ? {
      "Authorization": `Token ${token}`
    } : {};

    headers["Content-Type"] = "application/json"

    return fetch(`${API_BASE_URL}${url}`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(data)
    })
  },  

  putFD: async (url: string, data: KeyedObject, files: KeyedObject) => {

    const token = fetchService.getToken()
    const headers: KeyedObject = token ? {
      "Authorization": `Token ${token}`
    } : {};

    const formData = new FormData();

    for (const [key, value] of Object.entries(data)) {
        // @ts-ignore
        formData.append(key, value);
    }

    for (const [key, value] of Object.entries(files)) {
        // @ts-ignore
        formData.append(key, value);
    }    

    return fetch(`${API_BASE_URL}${url}`, {
      method: 'PUT',
      headers: headers,
      body: formData
    })
  },  


};

export const fetcher = async (args: string | [string]) => {
  const [url] = Array.isArray(args) ? args : [args];

  const res: KeyedObject = await fetchService.get(url);

  return res.data;
};

export const fetcherPost = async (args: string | [string, KeyedObject]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res: KeyedObject = await fetchService.post(url, { ...config });

  return res.data;
};


/* 


async function uploadDataWithFile(file, userData) {
  const formData = new FormData();
  
  // 1. Add the JSON data (usually as a string)
  formData.append("data", JSON.stringify(userData));
  
  // 2. Add the file
  formData.append("file", file);

  try {
    const response = await fetch("https://example.com", {
      method: "POST",
      body: formData,
      // NOTE: Do NOT set Content-Type header here!
    });
    const result = await response.json();
    console.log(result);
  } catch (error) {
    console.error("Error:", error);
  }
}

====


const formData = new FormData();
const fileField = document.querySelector('input[type="file"]');

formData.append('username', 'abc123');
formData.append('avatar', fileField.files[0]);

fetch('https://example.com/profile/avatar', {
  method: 'PUT',
  body: formData
})
.then((response) => response.json())
.then((result) => {
  console.log('Success:', result);
})
.catch((error) => {
  console.error('Error:', error);
});


====

    const formData = new URLSearchParams();
    formData.append("username_email_phone_number", usernameEmailOrPhoneNumber);
    formData.append("password", password);
    formData.append("_source", "app");

    try {
      // Make an API call to the specified endpoint
      const response = await fetch(`${constants.API_BASE_URL}/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      const responseData = await response.json();

      if (responseData.success !== false) {
        const userDataFromResponse = responseData.session_data;
        ToastMessage(t("youAreLoggedIn"), false);
        dispatch(onLogin(userDataFromResponse));
        
      } else {
        ToastMessage("User not found", true);
      }
    } catch (error) {
      // ToastMessage(`An error occurred while logging in ${error}`, true);
      ToastMessage(
        `An error occurred while logging in: You may want to check your credentials`,
        true
      );
    }
  };

====

TODO - replace in code

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await fetchService.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await fetchService.post(url, { ...config });

  return res.data;
};

export function redirectWithBasePath(path: string) {
  const basePath = import.meta.env.VITE_APP_BASE_NAME || process.env.VITE_APP_BASE_NAME || ''; // adjust for Vite, CRA, etc.
  window.location.pathname = `${basePath.replace(/\/$/, '')}${path}`;
}

*/

/*

EXAMPLE


// main.js
import { apiService } from './apiService.js';

async function loadUserData(userId) {
  try {
    const userData = await apiService.get(`/users/${userId}`);
    console.log('User Data:', userData);
  } catch (error) {
    console.error('Failed to load user data:', error.message);
  }
}

loadUserData(1);

*/


/*

Old response helpers

export const saveResponseMessagesToSS = (status: KeyedObject) => {
  try {
    sessionStorage.setItem("responseMessage", JSON.stringify(status))
  } catch (error) {}
}

export const deleteResponseMessagesFromSS = () => {
  sessionStorage.removeItem('responseMessage');
}

export const getResponseMessagesFromSS = () => {
  let status = null;
  try {
    status = JSON.parse(sessionStorage.getItem('responseMessage') || '')
  } catch (error) {
    status = null;
  }
  // We save status in session once - so delete after
  deleteResponseMessagesFromSS();
  return status;
}

export const getResponseMessages = (status: KeyedObject) => {
    const msgArr = [];
    const { t } = useTranslation();

    msgArr.push(t(status.message))

    if (status.response && status.response.errors) {
        Object.keys(status.response.errors).forEach(key => {
            const val = status.response.errors[key];
            msgArr.push(`${key}: ${t(val)}`)
        })
    }

    const messages = msgArr.map((item, i) =>
        <p key={`${i}_${generateRandomString(10)}`}>
        {item}
        </p>
    )

    return <>
    
        { status.type ? (
            <>
            { status.type == "success" ? (
                <div className="shims-center p-4 border rounded-lg border-green-200 dark:border-[#6b4423] bg-green-50 dark:bg-[#2d1b13] mb-5">
                    <div className="text-black-700 dark:text-black-400">
                    {messages}
                    </div>
                </div>          
            ) : ''}
            { status.type == "error" ? (
                <div className="shims-center p-4 border rounded-lg border-red-200 dark:border-[#6b4423] bg-red-50 dark:bg-[#2d1b13] mb-5">
                    <div className="text-red-700 dark:text-red-400">
                    {messages}
                    </div>
                </div>          
            ) : ''}
            </>
            ) : ''
        }
    </>

}

*/

/*

OLD fetches

export async function fetchServerSearch(kwargs: KeyedObject) {

  await get(`${API_URLS.search}?term=${kwargs.searchTerm}`)
  .then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  })
  .then(data => {
    kwargs.callback(data)
  })
  .catch(error => {
  })
  .finally(() => {
  })
};

export async function fetchProjectUsers(kwargs: KeyedObject) {

  await get(`${API_URLS.getProjectMembers}`)
  .then(response => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  })
  .then(data => {
    kwargs.callback(data)
  })
  .catch(error => {
  })
  .finally(() => {
  })
};

*/